import { commonStore } from '../../global-store/subjects/common';
import logger from '../../services/logging/logging-service';
import { satelliteTracker } from '../../services/tracking/satellite-tracking-service';
import { forEach } from '../../utils/array-utils';
import { hideElement, unHideElement } from '../../utils/dom-utils';
import { VIDEO_PLAYER_STATUS } from '../video-player/constants';
import { init as initPlayers } from '../video-player/init-players';

const U_VIDEO_STICKY_CLASS = 'u-video-sticky';
const STICKY_STATE = 'sticky';
const IS_CLOSED_STATE = 'closed';
const PLAYER_LIVE_HOOK = '.j-player-live-slim';
const EXT_LINK_BUTTON_CLASS = '.c-tv-card__ext-link';
const HEADER_AD_LABEL_CLASS = '.c-tv-card__header .c-tv-card__ad-label';
const HEADER_CLOSE_BUTTON_CLASS = '.c-tv-card__header .c-tv-card__close';
const IS_CLOSED_BUTTON_CLASS = '.c-tv-card__is-closed';

export const init = (() => {
  let scrolled;
  let playerLive;

  return ($tvCardSlim) => {
    logger.info('[TV - CARD] init TV card SLIM');
    const $adLabel = $tvCardSlim.querySelector(HEADER_AD_LABEL_CLASS);
    const $closeButton = $tvCardSlim.querySelector(HEADER_CLOSE_BUTTON_CLASS);
    const $isClosedButton = $tvCardSlim.querySelector(IS_CLOSED_BUTTON_CLASS);
    const $extLinkButton = $tvCardSlim.querySelector(EXT_LINK_BUTTON_CLASS);

    const setTvCardSticky = () => {
      $tvCardSlim.classList.add(U_VIDEO_STICKY_CLASS);
      $tvCardSlim.dataset.state = STICKY_STATE;
      satelliteTracker.trackInWeb('generic_interaction', { interaction_name: 'live-sticky' });
    };

    const handlePageScroll = () => {
      document.removeEventListener('scroll', handlePageScroll);
      scrolled = true;
      setTvCardSticky();
      unHideElement($tvCardSlim);
      const $playersLive = document.querySelectorAll(PLAYER_LIVE_HOOK);
      const playersLive = initPlayers($playersLive);
      playerLive = playersLive.playerList[0];
      playerLive.on(VIDEO_PLAYER_STATUS.PLAY, () => {
        hideElement($adLabel);
        unHideElement($closeButton);
      });
    };

    const handleCloseClick = () => {
      playerLive.pause();
      $tvCardSlim.dataset.state = IS_CLOSED_STATE;
      satelliteTracker.trackInWeb('generic_interaction', { interaction_name: 'live-closed' });
    };

    const handleIsClosedClick = () => {
      $tvCardSlim.dataset.state = STICKY_STATE;
      playerLive.play();
      satelliteTracker.trackInWeb('generic_interaction', { interaction_name: 'live-open' });
    };

    const handleExtLinkClick = () => {
      const allPlayersOnPage = commonStore.getValue().playersOnPage;
      forEach((player) => {
        player.pause();
      })(allPlayersOnPage);
    };

    document.addEventListener('scroll', handlePageScroll);
    $closeButton.addEventListener('click', handleCloseClick);
    $isClosedButton.addEventListener('click', handleIsClosedClick);
    $extLinkButton.addEventListener('click', handleExtLinkClick);
  };
})();
